/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyVendorPaymentTracker from './pharmacy-vendor-payment-tracker';
import PharmacyVendorPaymentTrackerDetail from './pharmacy-vendor-payment-tracker-detail';
import PharmacyVendorPaymentTrackerUpdate from './pharmacy-vendor-payment-tracker-update';
import PharmacyVendorPaymentTrackerDeleteDialog from './pharmacy-vendor-payment-tracker-delete-dialog';

const PharmacyVendorPaymentTrackerRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyVendorPaymentTracker />} />
    <Route path="new" element={<PharmacyVendorPaymentTrackerUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyVendorPaymentTrackerDetail />} />
      <Route path="edit" element={<PharmacyVendorPaymentTrackerUpdate />} />
      <Route path="delete" element={<PharmacyVendorPaymentTrackerDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyVendorPaymentTrackerRoutes;
